export const en = {
    companion_add: 'Add companion',
    empty_title: 'On a business trip with your loved ones',
    empty_description: 'We will collect all services and reservations in one place for convenient travel planning for you and your loved ones',
};
